import { ART, JEWELRY} from "@/constant/routes"
import Art from "@/features/data/pages/art";
import Jewelry from "@/features/data/pages/jewelry";

export const routes = [
    {
      path: ART,
      element: <Art />,
      isPublic: false,
    },
    {
      path: JEWELRY,
      element: <Jewelry />,
      isPublic: false,
    },
];